import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {Formik} from 'formik'
import {Link, useNavigate} from 'react-router-dom'
import * as Yup from 'yup'
import * as Api from 'lib/api'
import {Button, Paper, TextField} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import {useAuthentication} from 'components/providers/AuthenticationProvider'
import LoaderButton from 'components/atoms/LoaderButton'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(3, 2),
  },
  formControl: {
    marginBottom: theme.spacing(2),
  },
  button: {
    marginRight: theme.spacing(1),
  },
}))

const UserSchema = Yup.object().shape({
  name: Yup.string().required('formValidations.required'),
  email: Yup.string()
    .required('formValidations.required')
    .email('formValidations.invalidEmail'),
})

export function InviteUserPage() {
  const classes = useStyles()
  const navigate = useNavigate()
  const {tenant} = useAuthentication()
  const intl = useIntl()

  return (
    <Paper className={classes.root}>
      <Formik
        validationSchema={UserSchema}
        onSubmit={async (values) => {
          try {
            const user = await Api.inviteUser(tenant.id, values)
            navigate('/users/' + user.id)
          } catch (e) {
            // Existing behavior: fail silently.
            // Formik will set isSubmitting to false once this async function completes.
          }
        }}
        initialValues={{name: '', email: ''}}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              id="name"
              name="name"
              label={intl.formatMessage({id: 'name'})}
              className={classes.formControl}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.name}
              error={touched.name && Boolean(errors.name)}
              helperText={
                touched.name &&
                errors.name &&
                intl.formatMessage({id: errors.name})
              }
              autoFocus
            />

            <TextField
              fullWidth
              id="email"
              name="email"
              type="email"
              label={intl.formatMessage({id: 'email'})}
              className={classes.formControl}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
              error={touched.email && Boolean(errors.email)}
              helperText={
                touched.email &&
                errors.email &&
                intl.formatMessage({id: errors.email})
              }
            />

            <LoaderButton
              variant="contained"
              color="primary"
              className={classes.button}
              type="submit"
              isLoading={isSubmitting}
              loadingText={intl.formatMessage({id: 'invitingUser'})}
            >
              <FormattedMessage id="inviteUser" />
            </LoaderButton>
            <Button
              component={Link}
              to="/users"
              variant="contained"
              className={classes.button}
            >
              <FormattedMessage id="buttons.cancel" />
            </Button>
          </form>
        )}
      </Formik>
    </Paper>
  )
}
export default InviteUserPage
